


























import { computed, defineComponent } from "@vue/composition-api";
import { Banner } from "@scrile/api-provider/dist/api/BannersProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import providers from "@/lib/api";
import { isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getProfileUrl } from "@/lib/urlHelpers";
import ProfileHeaderBackground from "@/components/ProfileHeaderBackground";

const ERROR_PLACEHOLDER = "/img/profile-placeholder.png";

export interface SliderItem {
  performer?: UserPublicData;
  banner?: Banner;
}

export default defineComponent({
  name: "LandingSliderItem",
  components: { ProfileHeaderBackground },
  props: {
    item: { type: Object as () => SliderItem, required: true },
    delayTimer: { type: Number, default: 0 },
    active: { type: Boolean, default: false },
    internalLinkMode: { type: Boolean, default: false },
  },
  setup(props) {
    const link = computed(() => (props.item.performer ? getProfileUrl(props.item.performer) : props.item.banner?.link));
    const isVideo = computed<boolean>(
      () => !!props.item.performer?.background && isVideoFile(props.item.performer.background)
    );
    const isReady = computed<boolean>(() => props.item.performer?.background?.processingStatus === "OK");
    const url = computed<string>(() => {
      if (props.item.banner)
        return props.item.banner.image ? MediaFilesController.getFileUrl(props.item.banner.image.urlPart) : "__empty";
      if (!props.item.performer?.background) return "__empty";
      if (props.item.performer.background?.processingStatus === "ERROR") return ERROR_PLACEHOLDER;

      const urlPart = props.item.performer.background.urlPart;
      if (isImageFile(props.item.performer.background)) return MediaFilesController.getImageThumbnail(urlPart, "1080p");
      if (!isReady.value && isVideo.value) return MediaFilesController.getVideoThumbnail(urlPart, "1080p");
      return "";
    });
    const videoSrc = computed<string>(() => {
      if (!props.item.performer?.background || !isReady.value || !isVideo.value || url.value) return "";
      return MediaFilesController.getVideoUrl(props.item.performer.background?.urlPart);
    });
    const handleClick = () => {
      providers.LinksStatsProvider.linksClick({
        data: { link: `banner_${props.item.banner?.id}`, userId: "1" },
      });
    };

    return { link, url, videoSrc, handleClick };
  },
});
